import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>HARDWARE AUTOMATION</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 Our hardware automation solutions are engineered to optimize mechanical and electrical systems through advanced control technologies. 
We design and integrate systems involving Microcontrollers, sensors & actuators to automate tasks across industries such as manufacturing, energy, and logistics. 
Our focus is on improving operational speed, reliability, and precision while reducing downtime and human error.
{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
  <Container>
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i className="bi bi-boxes fa-3x mb-3 text-primary"></i>
        <hr className="my-3" />
        <h5>Embedded Systems</h5>
        <div className="btSubTitle small">
          We specialize in the design and development of embedded systems—dedicated computing solutions engineered directly into hardware to perform specific, mission-critical tasks. 
Our core expertise spans microcontrollers, microprocessors, and custom-designed PCBs (Printed Circuit Boards), enabling real-time control and automation across industrial, automotive, consumer electronics, and IoT domains. 

        </div>
       
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-patch-minus fa-3x mb-3 text-success"></i>
        <hr className="my-3" />
        <h5>Sensors and Actuators</h5>
        <div className="btSubTitle small">
         Our embedded solutions integrate advanced sensors to monitor critical physical parameters in production environments. 
Precision actuators like motors, solenoids, and pneumatic cylinders, ensure seamless conversion of electrical signals into mechanical actions.


        </div>
      
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-arrows-move fa-3x mb-3 text-danger"></i>
        <hr className="my-3" />
        <h5>Motion Control Systems</h5>
        <div className="btSubTitle small">
          Our motion control systems are engineered for high-precision applications across robotics & automated industrial equipment. 
These systems deliver accurate control over position, velocity, and acceleration of motors and mechanical assemblies, ensuring smooth and coordinated motion in dynamic production environments.

        </div>
        
      </Col>
    </Row>
    <br />
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i class="bi bi-diagram-3 fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Communication Protocols</h5>
        <div className="btSubTitle small">
          We implement robust and standardized communication protocols to enable seamless data exchange between embedded systems, sensors, controllers, and cloud platforms. 
Our expertise spans protocols such as CAN, I2C, SPI, UART, Modbus, and MQTT, ensuring reliable, real-time communication in industrial automation, automotive electronics, and IoT-based systems.

        </div>
      
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-motherboard fa-3x mb-3 text-secondary"></i>
        <hr className="my-3" />
        <h5>Real-Time Monitoring and Control</h5>
        <div className="btSubTitle small">
       Our systems are engineered for real-time monitoring and control, enabling instant feedback and responsive action across critical industrial operations. 
By continuously capturing data from sensors and controlling actuators with minimal latency, we ensure precision, safety, and efficiency in dynamic environments.

        </div>
       
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-arrow-left-right fa-3x mb-3 text-info"></i>
       
        <hr className="my-3" />
        <h5>Integration with Software Automation</h5>
        <div className="btSubTitle small">
         We deliver end-to-end solutions that seamlessly integrate embedded hardware with software automation platforms, enabling unified control, data visualization, and intelligent decision-making. 
Our systems support connectivity with Embedded systems and cloud-based dashboards to streamline workflows and enhance operational agility.

        </div>
      
      </Col>
    </Row>
  </Container>
</section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
